import { number } from 'prop-types';

import clock from '~/assets/images/icons/clock.svg';

import style from './DailyRewardCountdownText.module.scss';

export default function DailyRewardCountdownText({ hours, minutes }) {
  return (
    <div className={style.dailyRewardTimer}>
      <img
        className={style.clock}
        src={clock}
        alt="clock"
      />
      <p>{`${hours}h ${minutes}min`}</p>
    </div>
  );
}

DailyRewardCountdownText.propTypes = {
  hours: number,
  minutes: number,
};
